// extensions/ImageFigure.js
import { Node } from '@tiptap/core'
import { VueNodeViewRenderer } from '@tiptap/vue-3'
import ImageFigureView from '../ImageFigureView.vue'

export const ImageFigure = Node.create({
    name: 'imageFigure',

    group: 'block',
    content: 'image figcaption',
    defining: true,
    isolating: true,

    addAttributes() {
        return {
            marginTop: {
                default: 0,
            },
            marginBottom: {
                default: 0,
            },
        }
    },

    parseHTML() {
        return [{ tag: 'figure.editor-figure' }]
    },

    renderHTML({ HTMLAttributes }) {
        return [
            'figure',
            { class: 'editor-figure', ...HTMLAttributes },
            0,
        ]
    },

    addNodeView() {
        return VueNodeViewRenderer(ImageFigureView)
    },
})
